export default __webpack_public_path__ + "static/media/slots.348d8b6a.webp";